<opac-button *ngIf="showBackButton()" class="back-button" type="text" (click)="goBack()">
  <opac-icon slot="start" icon="navigate_back"></opac-icon>
  {{ 'common.back' | translate }}
</opac-button>

<div class="header">
  <h1>{{ 'user.favorites.title' | translate }}</h1>
  <opac-button class="more-actions" [opac-menu-trigger]="listActionsMenu"
                [ariaLabel]="'lists.moreActions' | translate" [opacTooltip]="'lists.moreActions' | translate">
    <opac-icon icon="more_vertical" slot="only-icon"></opac-icon>
  </opac-button>
</div>

<opac-menu #listActionsMenu>
  <opac-menu-item (selected)="addTitles()">
    <opac-icon icon="add"></opac-icon>
    {{ 'lists.addTitles' | translate }}
  </opac-menu-item>

  <opac-menu-item *ngIf="favoriteFacade.paginatedFavorites.items.length > 0" (selected)="showDeleteAllFavoritesDialog.set(true)">
    <opac-icon icon="delete"></opac-icon>
    {{ 'common.deleteAll' | translate }}
  </opac-menu-item>
</opac-menu>

<span class="header-subtitle">
  <span>{{ favoriteFacade.paginatedFavorites.itemsTotal }} {{ (favoriteFacade.paginatedFavorites.itemsTotal === 1 ? "common.item" : "common.items") | translate }}</span>
</span>

<opac-divider></opac-divider>

<div class="skeleton-container" *ngIf="(isLoading$ | async)">
  <opac-card-item-skeleton *ngFor="let i of [1, 2, 3, 4, 5, 6]"></opac-card-item-skeleton>
  <opac-gradient></opac-gradient>
</div>

<opac-no-results-cta *ngIf="emptyFavorites$ | async">
  {{ 'lists.noFavorites' | translate }}
  <opac-button type="secondary" (click)="addTitles()">
    {{ 'lists.addElements' | translate }}
  </opac-button>
</opac-no-results-cta>

<app-record-card-grid *ngIf="favoriteFacade.paginatedFavorites.items.length">
  <ng-container *ngFor="let favorite of favoriteFacade.paginatedFavorites.items">
    <app-user-favorite-item *ngIf="favorite.available" [favorite]="favorite"></app-user-favorite-item
  ></ng-container>
</app-record-card-grid>

<opac-infinite-scroll
  [disabled]="(emptyFavorites$ | async) || (isLoading$ | async) || favoriteFacade.paginatedFavorites.page === favoriteFacade.paginatedFavorites.numPages -1"
  [threshold]="100"
  (load)="loadMore()"></opac-infinite-scroll>

<opac-confirmation-dialog
  [acceptLabel]="'common.accept'"
  [open]="showDeleteAllFavoritesDialog()"
  [title]="'common.deleteAll' | translate"
  (accept)="removeAllFavorites()"
  (cancel)="showDeleteAllFavoritesDialog.set(false)">
  <p>{{'messages.favorites.confirmRemoveAll' | translate}}</p>
</opac-confirmation-dialog>
